import { render, staticRenderFns } from "./posting.vue?vue&type=template&id=b8a356dc&"
import script from "./posting.vue?vue&type=script&lang=js&"
export * from "./posting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports